export default __webpack_public_path__ + "static/wheel_chair_b.97848ac8047d42c40628a15b048c8fb1.svg";